interface RouteValue {
  path: string
  isProtected?: boolean
  backPath?: string
}

const routes = {
  HYCS_GET_STARTED: {
    path: 'hycs/get-started/',
  },
  PERSONAL_INFO: {
    path: 'hycs/personal-info/',
  },
  ENTER_PHONE: {
    path: 'hycs/enter-phone/',
  },
  FINANCES: {
    path: 'hycs/finances/',
  },
  EMPLOYMENT: {
    path: 'hycs/employment/',
  },
  WELCOME: {
    path: 'hycs/welcome/',
  },
  VERIFY_PHONE: {
    path: 'hycs/verify-phone/',
  },
  VERIFY_EMAIL: {
    path: 'hycs/verify-email',
  },
  SETTING_UP: {
    path: 'hycs/setting-up/',
  },
  HOME_ADDRESS: {
    path: 'hycs/home-address/',
  },
  VERIFY_IDENTITY: {
    path: 'hycs/verify-identity/',
  },
  FUND_SUCCESS: {
    path: 'hycs/fund-success/',
  },
  DISCLOSURES: {
    path: 'hycs/disclosures/',
  },
  SECURE_ACCOUNT: {
    path: 'hycs/secure-account/',
  },
  FUND_ACCOUNT: {
    path: 'hycs/fund-account/',
  },
  DOCUMENT_VERIFICATION: {
    path: 'hycs/document-verification/',
  },
  ERROR: {
    path: 'error/',
  },
  ACCOUNT_EXISTS: {
    path: 'account-exists/',
  },
  TECHNICAL_ISSUES: {
    path: 'technical-issues',
  },
  DOCUMENT_VERIFICATION_COMPLETE: {
    path: 'hycs/document-verification-complete/',
  },
  DEVICE_NOT_SUPPORTED: {
    path: 'device-not-supported/',
  },
  DECLINE: {
    path: 'decline/',
  },
  LINK_EXPIRED: {
    path: 'link-expired/',
  },
  UNDER_REVIEW: {
    path: 'under-review/',
  },
  HYCS_HOME: {
    path: 'hycs/',
  },
  MANUAL_REVIEW: {
    path: 'hycs/manual-review/',
  },
  //INTEGRATION:EnrollmentConst
} as const

// Record<string, RouteValue> doesn't suggest Route, so we need to define the following types to have keys suggested by TypeScript
type Routes = typeof routes
type RouteKey = keyof Routes
type Route = Record<RouteKey, RouteValue>
export const ROUTES = routes as Route
